import React, { Component } from 'react';
import {THUMBNAIL_WIDTH} from 'components/mix/constants.js';
import SendMuteButton from 'components/mix/SendMuteButton.js';

class SendThumbnail extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div>
              <SendMuteButton partWidth={THUMBNAIL_WIDTH} send={this.props.send}/>
              <div className="group-thumbnail">
              </div>
            </div>);
    }
}

export default SendThumbnail;
